.hours-summary-scroll { min-width: 0; overflow-x: auto; }
.hours-summary-table { width: 100%; min-width: 700px; border-collapse: collapse; text-align: left; font-size: 12px; }
.hours-summary-table th, .hours-summary-table td { padding: 6px; border-bottom: 1px solid #e2e8f0; vertical-align: top; }
.hours-summary-table thead, .hours-summary-day { background: #f8fafc; }
.hours-summary-day { font-weight: 600; }
.hours-print-dialog { width: min(1100px, calc(100vw - 24px)); max-width: none; max-height: calc(100dvh - 24px); padding: 0; }
.hours-print-dialog::backdrop { background: rgb(15 23 42 / 45%); }
.hours-print-toolbar { position: sticky; top: 0; background: white; border-bottom: 1px solid #e2e8f0; }
.hours-print-pages { display: grid; gap: 12px; padding: 12px; }
@media print {
  body:has(> .hours-print-dialog[open]) { overflow: visible !important; background: white !important; }
  body:has(> .hours-print-dialog[open]) > :not(.hours-print-dialog) { display: none !important; }
  .hours-print-dialog[open] { position: static; width: auto; max-height: none; height: auto; overflow: visible; border: 0; margin: 0; }
  .hours-print-dialog::backdrop, .hours-print-toolbar { display: none; }
  .hours-print-pages { display: block; padding: 0; }
  .hours-print-sheet + .hours-print-sheet { break-before: page; }
  .hours-print-sheet .hours-summary { display: block; border: 0; padding: 0; }
  .hours-print-sheet header, .hours-print-sheet tr { break-inside: avoid; }
  .hours-print-sheet header { margin-bottom: 12px; }
  .hours-summary-scroll { overflow: visible; }
  .hours-summary-table { min-width: 0; table-layout: fixed; font-size: 10px; }
  .hours-summary-table th, .hours-summary-table td { overflow-wrap: anywhere; padding: 5px; }
  .hours-summary-table thead { display: table-header-group; }
}
